module.exports = __webpack_public_path__ + "static/media/hp-section-04.51f47035.jpg";